import { useTranslation } from 'react-i18next';
import { useGetRequiredRule, useSliderFilterValidation } from '@/hooks';

export const useCharacteristicsValidationRules = () => {
  const { t } = useTranslation(['validations']);

  const requiredRule = useGetRequiredRule({ t });
  const getSliderValidationRule = useSliderFilterValidation({ t });

  return { requiredRule, getSliderValidationRule };
};
